export default {
    colors: {
        primary: '#ed8936',
        success: '#63af13',
        modalBackground: '#e7e7e7',
        background: '#f8f8f8'
    },
};